import React from 'react'
import GrowthWheelEditorLanding from '../../components/GrowthWheelComponents/GrowthWheelEditorLanding'
import { User } from '../../types/User'

const GrowthWheelEditor = ({ user }: { user: User }) => {
  return (
    <main className="container-fluid mb-5">
      <GrowthWheelEditorLanding user={user} />
    </main>
  )
}

export default GrowthWheelEditor
